import React, { Component } from 'react';

import Badge from 'material-ui/Badge';
import BadgeIcon from 'material-ui/svg-icons/social/notifications';
import IconButton from 'material-ui/IconButton';
import { Link } from 'react-router';

import NotificationStore from '../../stores/NotificationStore';
import NotificationActions from '../../actions/NotificationActionCreator';

const style = {
    badge: {},
    container: {
        padding: 0
    },
    icon: {
        padding: 0
    }
};


class NotificationBadge extends Component {

    constructor (props) {
        super(props);
        this.state = {
            count: 0
        };
        this.onChange = this.onChange.bind(this);
    }


    componentDidMount() {
        NotificationStore.addChangeListener(this.onChange);
        NotificationActions.getAll();
    }

    componentWillUnmount() {
        NotificationStore.removeChangeListener(this.onChange);
    }

    render() {

        if (this.state.count === 0) {
                style.badge.display = 'none';
        }

        return (
                <Link to="/dashboard/notifications">
                    <Badge 
                        badgeContent={this.state.count} 
                        secondary={true} 
                        style={style.container} 
                        badgeStyle={style.badge}
                    >
                        <IconButton style={style.icon} tooltip="notifications">
                            <BadgeIcon color="white"/>
                        </IconButton>
                    </Badge>
                </Link>
        )
    }

    onChange() {
        let unread = NotificationStore.getAllUnread();
        let count = unread.length;
        this.setState({count: count});
    }
}

export default NotificationBadge;